import React, { memo } from 'react'

import UnauthorizedLayout from '../../../components/unauthorizedLayout/UnauthorizedLayout'

const UnauthorizedLayoutWrapper = (props) => {
  return <UnauthorizedLayout {...props} />
}

export default memo(UnauthorizedLayoutWrapper)
